<script setup>
import { cn } from "@/lib/utils";
import { alertVariants } from ".";

var props = defineProps({
  class: { type: null, required: false },
  variant: { type: null, required: false },
});
</script>

<template>
  <div
    :class="cn(alertVariants({ variant: variant }), props.class)"
    role="alert"
  >
    <slot />
  </div>
</template>
